import { UserProvider } from "@auth0/nextjs-auth0";
import { ThemeProvider } from "theme-ui";
import theme from "../config/theme";
import { RecoilRoot } from "recoil";

// import { Elements } from "@stripe/react-stripe-js";
// import { loadStripe } from "@stripe/stripe-js";

// console.log("Stripe key", process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY);
// const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLIC_KEY);

function MyApp({ Component, pageProps }) {
  return (
    <ThemeProvider theme={theme}>
      <UserProvider>
        <RecoilRoot>
          {/* <Elements stripe={stripePromise}> */}
          <Component {...pageProps} />
          {/* </Elements> */}
        </RecoilRoot>
      </UserProvider>
    </ThemeProvider>
  );
}

export default MyApp;
